import { isProduction } from "@/helpers/global/env.func";

export const config = {
  company: 'scb',
  market: 'hk',
  locale: 'hk',
  gtm:'hk_gtm',
  version: 'itrade7.5-scb-v7.0.1',
  company_title: 'company_title',
  language: ['zh_TW', 'zh_CN', 'en_US'],
  routerPrefix: isProduction() ? (window.config?.webPath && `/${window.config.webPath}/hks` || '/hks') : '',
  thirdPartyLink: 'https://www.shacomsecurities.com.hk/as/cc',
  securityTchLink:'https://www.shacombank.com.hk/tch/main/security.jsp',
  rsa_modulus: "97649605335c016a02c8482f8a1fb009171ef741c375cc03f7e8d221b578ee68a38e6db406c46f51708192de0a25452122dddd0f468e51b7c16a3a962afa7516701cac88f2947ed70bb4f00cbea1c42d26eb161f174e22515cc7a642dfe47c185234d0448836cc0c2034950f7a8e003a9f318d9f1551119d7bde3a6b103dfd85",
  rsa_exponent: "10001",
  checkTabs: false,
  apis: {
    winvestorApi: false,
    mdsApi: false,
  },
  actions:{
    app:{
      order_confirm:true,
      place_order:true,
      stock_theme:true
    },
    trading:{
      market_label:true,
      autoRefreshOrderEnquiry: isProduction() ? (window.config?.companyOptions?.trading?.autoRefreshOrderEnquiry) : 5000,
      autoCheckSession: isProduction() ? (window.config?.companyOptions?.trading?.autoCheckSession) : 300000
    },
    ipo:{
      allotment_result_enquiry: true
    }
  },
  layouts: {
    fullLayout: {
      logoImgName: 'logo_dark.svg',
    },
    mainLayout: {
      logoImgName: 'logo_dark.svg',
    }
  },
  helpers:{
    functions:{
      accountToOption: true,
    }
  },
  pages: {
    login: {
      ctrl: { securityTips: false }
    },
    trade: {
      rewrite: true,
      ctrl: { 
        personalsetting:true
      },
    },
    e_message:{
      rewrite:true
    },
    ipo:{
      rewrite:true,
      ctrl:{ detail : true }
    },
    accountdata:{
      rewrite:true
    },
    change_password:{
      rewrite:true
    }
  },
  constants: {
    winVest: {},
  }
}